import React, { createContext, useContext, useReducer } from 'react';
import reducer from './reducer';

export const initialState = {
  adminState: '',
  organisations: [],
  user: {},
  users: [],
}

export const AdminStateContext = createContext();
export const AdminDispatchContext = createContext();

function AdminContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <AdminStateContext.Provider value={state}>
      <AdminDispatchContext.Provider value={dispatch}>
        {children}
      </AdminDispatchContext.Provider>
    </AdminStateContext.Provider>
  )
}

function useAdminDispatch() {
  const context = useContext(AdminDispatchContext)
  if (context === undefined) {
    throw new Error('useAdminDispatch must be used within a AdminState Provider')
  }
  return context
}

function useAdminState() {
  const context = useContext(AdminStateContext)
  if (context === undefined) {
    throw new Error('useAdminState must be used within a AdminState Provider')
  }
  return context
}

export { AdminContext, useAdminDispatch, useAdminState };